import { bootstrap } from "bootstrap";
import { jquery } from "jquery";
import SmoothScroll from 'smooth-scroll';
import LazyLoad from "vanilla-lazyload";

$(document).ready(function(){
	//Init lazy loading images
	var lazyLoadInstance = new LazyLoad({
		elements_selector: ".lazy",
	});
	
	//Init carousel
	$('.carousel').carousel();
	
	//Modal
	$("[custom-modal]").unbind("click");
	$("[custom-modal]").click(function(e){
		var modal = $($(this).attr("custom-modal"));
		
		modal.addClass("show");
		$("html,body").css("overflow","hidden");
	});
	
	$(".custom-modal").unbind("click");
	$(".custom-modal").click(function(e){
		if(!$(e.target).hasClass("prev") &&
		   !$(e.target).hasClass("next") &&
		   !$(e.target).hasClass("prev-arrow-img") &&
		   !$(e.target).hasClass("next-arrow-img")
	    ){
			$(this).removeClass("show");
			$("html,body").css("overflow","visible");
		}
	});
	
	//Cookies
	if(localStorage.getItem('cookiesAccepted') == null){
		$("#cookies-banner").removeClass("hide");
	}else{
		$("#cookies-banner").addClass("hide");
	}
	
	$("#accept-cookies-button").unbind("click");
	$("#accept-cookies-button").bind("click",function(){
		$.ajax({
		  type: "POST",
		  url: "/api/cookies/accept",
		  data: {Accept: true},
		  success: function(data){
			  if(JSON.parse(data).message.toLowerCase() == 'true'){
				localStorage.setItem('cookiesAccepted', "true");
				$("#cookies-banner").hide("400");  
			  }else{
				$("#cookies-banner").show("400");   
			  }
		  }
		});
	});
	
	//Contact
	$("#contact-form-button").unbind("click");
	$("#contact-form-button").bind("click",function(e){
		var messageValid = validateInput("#message");
		var emailValid = validateInput("#email");
		var lastNameValid = validateInput("#lastName");
		var firstNameValid = validateInput("#firstName");
		
		$("#message-accept-privacy-disclaimer").hide();
		$("#message-sent").hide();
		$("#message-error").hide();
				
		if($("#privacyDisclaimer").prop('checked') && messageValid && emailValid && lastNameValid && firstNameValid){
			gtag_report_conversion();
			
			$.ajax({
			  type: "POST",
			  url: "/contact",
			  data: $("#contact-form").serialize(),
			  success: function(data){			  
				$("#message-sent").show();
				
				var messageSentInterval = setInterval(function(){
					$("#message-sent").fadeOut(300, function(){
						$("#contact-form")[0].reset();
						$([document.documentElement, document.body]).animate({
							scrollTop: $("#contact").offset().top
						}, 500);
					});
					
					clearInterval(messageSentInterval);	
				}, 2500);
			  },
			  error: function(){
				$("#message-error").show(); 
			  }
			});			
		}else{
			$("#message-accept-privacy-disclaimer").show();
		}

		e.preventDefault();
	});
	
	//Custom modal
	$(".custom-modal-control").unbind("click");
	$(".custom-modal-control").click(function(){
		var modal = $(this).closest(".custom-modal");
		var currentSort = parseInt(modal.find(".custom-modal-img.show").attr("carousel-sort"));
		var totalImages = modal.find(".custom-modal-img").length;
		
		modal.find(".custom-modal-img.show").removeClass("show");
		
		if($(this).hasClass("prev")){
			currentSort -= 1;
			if(currentSort < 0){
				currentSort = totalImages - 1;
			}
		}else{
			currentSort += 1;
			if(currentSort > totalImages - 1){
				currentSort = 0;
			}
		}
		modal.find("[carousel-sort='" + currentSort + "']").addClass("show");
	});
	
	
	//Smooth scroll
	var scroll = new SmoothScroll('a[href*="#"]');
	
	//Close menu when navigating
	$(".nav-item, #scroll-to-top, .arrow-down, #logo-link").click(function(){
		$('#navbar').collapse('hide');
	});
	
	//Set items and animations when images are loaded
	var loadedInterval = setInterval(function(){
		if(lazyLoadInstance.loadingCount != undefined){
			if(lazyLoadInstance.loadingCount == 0){
				setItemsOnScroll();
				animateItemsOnScroll();
				setMenuOnScroll();
				
				$(window).on('scroll', function() { 
					setItemsOnScroll();
					animateItemsOnScroll();
					setMenuOnScroll();
				});
				
				$(window).resize(function() {
					setItemsOnScroll();
					animateItemsOnScroll();
					setMenuOnScroll();
				});
				
				removePreloader();				
				clearInterval(loadedInterval);
			}
		}
	}, 50);
	
	//Remove preloader after a few seconds anyway
	var preloaderInterval = setInterval(function(){
		removePreloader();	
		clearInterval(preloaderInterval);	
	}, 4000);
});

window.onerror = function (msg, url, lineNo, columnNo, error) {
  removePreloader();
  return false;
}

function setItemsOnScroll(){
	if ($(window).scrollTop() >= $("header").offset().top + $("header").outerHeight() - window.innerHeight && $(window).scrollTop() > 0) { 
		$(".arrow-down").removeClass("fixed");
		$(".arrow-down").removeClass("absolute");
	}else if($("#header-left-img").bottomIsInViewport()){
		$(".arrow-down").addClass("absolute");
		$(".arrow-down").removeClass("fixed");
	}else{
		$(".arrow-down").addClass("fixed");
		$(".arrow-down").removeClass("absolute");
	}

	if ($(window).scrollTop() >= $("header").offset().top + $("header").outerHeight() - window.innerHeight + 350 && $(window).scrollTop() > 0) { 
		$("#scroll-to-top").addClass("animate");
		$("#facebook-icon-side").addClass("animate");
		$("#instagram-icon-side").addClass("animate");
	}else{
		$("#scroll-to-top").removeClass("animate");
		$("#facebook-icon-side").removeClass("animate");
		$("#instagram-icon-side").removeClass("animate");
	} 	
}

function animateItemsOnScroll(){
	$("[animation]:not(.animate)").each(function() {
		if ($(this).topIsInViewport(200)) {
			$(this).addClass("animate");
		} 
	});
	$(".animate").each(function() {
		if (!$(this).topIsInViewport(0)) {
			$(this).removeClass("animate");
		} 
	});
}

function setMenuOnScroll(){
	if ($(window).scrollTop() >= 50){
		$("#menu").addClass("small");
	}else{
		$("#menu").removeClass("small");
	}
}

function initCustomModal(){
	var imgs = document.getElementById('slideshow').children;
	var interval = 8000;
	var currentPic = 0;
	imgs[currentPic].style.webkitAnimation = 'fadey '+interval+'ms';
	imgs[currentPic].style.animation = 'fadey '+interval+'ms';
	
	var infiniteLoop = setInterval(function(){
		imgs[currentPic].removeAttribute('style');
		if ( currentPic == imgs.length - 1) {
			currentPic = 0;
		} else {
			currentPic++;
		}
		imgs[currentPic].style.webkitAnimation = 'fadey '+interval+'ms';
		imgs[currentPic].style.animation = 'fadey '+interval+'ms';
	}, interval);
}

function removePreloader(){
	$(".custom-progress-container").fadeOut(300, function() { $(this).remove();});
	$("html, body").removeClass("loading");
}

function validateInput(element){
	var input = $(element)[0];
	input.reportValidity();
	return input.checkValidity();
}

$.fn.topIsInViewport = function(offset) {
	if(offset == undefined){
		offset = 0;
	}
	
	var elementTop = $(this).offset().top;
	var elementBottom = elementTop + $(this).outerHeight();

	var viewportTop = $(window).scrollTop();
	var viewportBottom = viewportTop + $(window).height();

	return elementTop <= viewportBottom - offset;
};

$.fn.bottomIsInViewport = function(offset) {
	if(offset == undefined){
		offset = 0;
	}
	
	var elementTop = $(this).offset().top;
	var elementBottom = elementTop + $(this).outerHeight();

	var viewportTop = $(window).scrollTop();
	var viewportBottom = viewportTop + $(window).height();
	
	return elementBottom <= viewportBottom - offset;
};
